const controlLoop = (callback: () => void, time?: number) => {
  let isPaused = false
  const interval = setInterval(() => {
    if (!isPaused) {
      callback()
    }
  }, time || 500)
  return {
    pause: () => { isPaused = true },
    play: () => { isPaused = false },
    destroy: () => clearInterval(interval)
  }
}

function isMobile () {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ]

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem)
  })
}

export {
  controlLoop,
  isMobile
}
